/* Fiches produit Slich — 17/09/2026.
 *
 * 1. Ouvre le configurateur depuis tout déclencheur marqué
 *    `data-slich-open-configurator` (comportement existant, conservé).
 * 2. Remonte la bande d'engagements juste sous le bloc d'achat quand la fiche
 *    ne porte pas de section Slich : sur le tableau lenticulaire, la
 *    description du marchand fait 1 556 px (2 151 px à 390) et enterrait la
 *    bande. Le contenu existe de toute façon dans le HTML : sans JavaScript, il
 *    reste simplement plus bas dans la page.
 * 3. Affiche une barre d'achat collante en bas d'écran sur téléphone, dès que
 *    l'action principale réelle (bouton « Personnaliser » du configurateur, ou
 *    « Ajouter au panier » natif) est passée au-dessus de la fenêtre. Mesuré le
 *    17/09/2026 : à 390 × 844, cette action était à y 1076 (fiche
 *    personnalisable) et y 1584 (tableau lenticulaire), pour une fenêtre qui
 *    s'arrête à 844.
 *
 * La barre ne prend jamais la place d'un dialogue : elle s'efface tant que le
 * bandeau de consentement Shopify occupe le bas de l'écran, quand le
 * configurateur est ouvert, quand un tiroir ou un dialogue est ouvert, et dans
 * le pied de page. Elle n'existe pas au-delà de 749 px de large (le CSS la
 * masque) — l'action y est déjà visible sans défiler.
 */
(() => {
  "use strict";

  const CONFIGURATOR_OPEN = "[data-geoprint-root] [data-geoprint-open]";
  // Classe du thème : l'identifiant de la colonne d'information est suffixé par
  // la section Shopify (« ProductInfo-template--…__main »), il ne s'adresse donc
  // pas à `#ProductInfo`. Idem pour le prix, publié sous
  // « price-template-template--…__main ».
  const PRODUCT_ROOT = ".product__info-container";

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-slich-open-configurator]");
    if (!trigger) return;
    const configurator = document.querySelector(CONFIGURATOR_OPEN);
    if (!configurator) return;
    configurator.click();
  });

  const root = document.querySelector(PRODUCT_ROOT);
  if (!root) return;

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden") return false;
    const box = element.getBoundingClientRect();
    return box.width > 1 && box.height > 1;
  };

  // 2. Bande d'engagements : remontée sous le bloc d'achat.
  const band = document.querySelector('[data-slich-reassurance][data-slich-band="standalone"]');
  const description = root.querySelector(".product__description");
  if (band && description && description.parentElement) {
    description.parentElement.insertBefore(band, description);
  }

  // 3. Barre d'achat collante.
  const narrowScreen = window.matchMedia("(max-width: 749px)");
  let bar = null;
  let refreshQueued = false;
  let poller = null;

  const priceText = () => {
    const item = document.querySelector(
      ".price__regular .price-item--regular, .price-item--regular, .price .price-item"
    );
    return (item?.textContent ?? "").replace(/\s+/g, " ").trim();
  };

  const supportText = () => {
    const claim = document.querySelector("[data-slich-reassurance] strong");
    return (claim?.textContent ?? "").replace(/\s+/g, " ").trim();
  };

  const primaryAction = () => {
    const opener = root.querySelector(CONFIGURATOR_OPEN);
    if (isVisible(opener)) {
      return {element: opener, mode: "configurator", label: "Personnaliser ma création"};
    }
    const add = root.querySelector('button[name="add"], .product-form__submit');
    if (isVisible(add)) {
      return {element: add, mode: "cart", label: "Ajouter au panier"};
    }
    return null;
  };

  // Le bas de l'écran est déjà pris : bandeau de consentement, configurateur
  // ouvert, tiroir panier, dialogue quelconque.
  const bottomIsTaken = () => {
    const banner = document.querySelector("#shopify-pc__banner");
    if (banner && window.getComputedStyle(banner).display !== "none") return true;
    if (root.querySelector('[data-geoprint-modal-open="true"]')) return true;
    if (document.querySelector("dialog[open]")) return true;
    const drawer = document.querySelector("cart-drawer.active, .drawer.active, .menu-drawer-container.active");
    return Boolean(drawer);
  };

  const footerInView = () => {
    const footer = document.querySelector(".footer");
    if (!footer) return false;
    return footer.getBoundingClientRect().top < window.innerHeight - 40;
  };

  const ensureBar = (action) => {
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "slich-buy-bar";
      bar.setAttribute("data-slich-buy-bar", "");
      bar.hidden = true;
      bar.innerHTML =
        '<span class="slich-buy-bar__price"><strong></strong><span></span></span>' +
        '<button type="button" class="slich-buy-bar__cta"></button>';
      bar.querySelector(".slich-buy-bar__cta").addEventListener("click", () => {
        const current = primaryAction();
        if (!current) return;
        current.element.click();
        schedule();
      });
      document.body.append(bar);
    }
    const price = bar.querySelector(".slich-buy-bar__price strong");
    const support = bar.querySelector(".slich-buy-bar__price > span");
    const cta = bar.querySelector(".slich-buy-bar__cta");
    const value = priceText();
    if (value && price.textContent !== value) price.textContent = value;
    const note = supportText();
    if (support.textContent !== note) support.textContent = note;
    if (cta.textContent !== action.label) cta.textContent = action.label;
    return bar;
  };

  const refresh = () => {
    refreshQueued = false;
    const action = primaryAction();
    if (!action) return;
    const element = ensureBar(action);
    const passed = action.element.getBoundingClientRect().bottom < 0;
    const show = narrowScreen.matches && passed && !bottomIsTaken() && !footerInView();
    element.hidden = !show;
    // Le bandeau de consentement et le configurateur changent d'état sans
    // défilement — le bandeau est résolu par Shopify après un choix, ce qui ne
    // produit ni défilement ni mutation visible. Tant que le client a dépassé
    // l'action principale et qu'il est sur téléphone, on revérifie doucement :
    // c'est le seul moment où l'état de la barre peut changer tout seul.
    const shouldPoll = narrowScreen.matches && passed;
    if (shouldPoll && !poller) {
      poller = window.setInterval(schedule, 900);
    } else if (!shouldPoll && poller) {
      window.clearInterval(poller);
      poller = null;
    }
  };

  function schedule() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(refresh);
  }

  window.addEventListener("scroll", schedule, {passive: true});
  window.addEventListener("resize", schedule);
  if (narrowScreen.addEventListener) narrowScreen.addEventListener("change", schedule);

  for (const selector of ["#shopify-pc__banner", "cart-drawer", "[data-geoprint-root]"]) {
    const target = document.querySelector(selector);
    if (!target || typeof window.MutationObserver !== "function") continue;
    new window.MutationObserver(schedule).observe(target, {
      attributes: true,
      attributeFilter: ["style", "class", "data-geoprint-modal-open"]
    });
  }

  schedule();
})();
